import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	statusFieldLabel: {
		id: 'issue-create.modal.create-form.status-field.status-field-label',
		defaultMessage: 'Status',
		description: 'Label for status field in issue create form',
	},
	unavailableStatusText: {
		id: 'issue-create.modal.create-form.status-field.unavailable-status-text',
		defaultMessage: "Your workflow doesn't allow issues to be created in this status",
		description: 'Tooltip text for disabled status transition',
	},
	helperText: {
		id: 'issue-create.modal.create-form.status-field.helper-text',
		defaultMessage: 'This is the initial status upon creation',
		description: 'Text to help with understanding what the status field is used for',
	},
	helperTextToBeFaded: {
		id: 'issue-create.modal.create-form.status-field.helper-text-to-be-faded',
		defaultMessage: "This is the issue's initial status upon creation",
		description:
			'Text to help with understanding what the status field is used for, before terminology refresh',
	},
	noEnabledTransitionsMessage: {
		id: 'issue-create.modal.create-form.status-field.no-enabled-transitions-message',
		defaultMessage: 'There are no statuses available for you to use',
		description:
			'Message shown inside the status field dropdown when no non-default statuses are available',
	},
	warningIconLabel: {
		id: 'issue-create.modal.create-form.status-field.warning-icon-label',
		defaultMessage: 'Warning',
		description: 'Accessibility label for the warning icon',
	},
	warningMessage: {
		id: 'issue-create.modal.create-form.status-field.warning-message',
		defaultMessage:
			'This field isn’t working right now. You can still create your issue and update the status later.',
		description:
			'Warning message to display when status in GIC has failed to load (this will replace `issue-create.modal.create-form.status-field.error-message)`',
	},
});
